const saClickTrackerEndpoint = '/api/tracker/click'
const saBase = (typeof window !== 'undefined') ? window.location.origin : ''

const clickTrack = (url: string, target = '_blank', params: Record<string, string | number | boolean> = {}) => {
  if (typeof window !== 'undefined') {
    try {
      const clickUrl = new URL(saClickTrackerEndpoint, saBase)
      clickUrl.searchParams.append('url', url)

      for (const key in params) {
        if (Object.prototype.hasOwnProperty.call(params, key)) {
          clickUrl.searchParams.append(key, String(params[key]))
        }
      }
      window.open(clickUrl.toString(), target, 'noopener,noreferrer')
    } catch (error) {
      console.error('Error constructing click tracking URL:', error)
      window.open(url, target, 'noopener,noreferrer')
    }
  }
}

export default clickTrack
